<div [formGroup]="reportGenerationForm" *ngIf="reportGenerationForm != null">
  <div class="row">
    <div class="col-12 col-md-6">
      <lib-multiselect
        [allowSelectAll]="true"
        formControlName="employeeIds"
        [options]="peopleIdOpts"
        [defaultButtonText]="'Select All Employee Numbers'"></lib-multiselect>
    </div>
    <div class="col-12 col-md-6">
      <lib-multiselect
        [allowSelectAll]="true"
        formControlName="employeeIds"
        [options]="peopleNameOpts"
        [defaultButtonText]="'Select All Employee Names'"></lib-multiselect>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      Year/Quarter <lib-quarter-picker formControlName="quarter"></lib-quarter-picker>
    </div>
    <div class="col-12 col-md-6">
      <lib-checkbox
        [label]="'Include Pickup/Successor Figures'"
        formControlName="includePickupSuccessorFigures"></lib-checkbox>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-2">Sorting Options:</div>
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="firstSortBy">First Sort By:</label>
        <select formControlName="firstSortBy" id="firstSortBy" class="form-control">
          <option *ngFor="let opt of sortOptions" [value]="opt.FirstSort">
            {{ opt.FirstSort }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label for="secondSortBy">Second Sort By:</label>
        <select formControlName="secondSortBy" id="secondSortBy" class="form-control">
          <option *ngFor="let opt of secondSortOptions" [value]="opt">{{ opt }}</option>
        </select>
      </div>
    </div>
  </div>
  <lib-report-buttons
    *ngIf="reportGenerationForm != null"
    [disabled]="reportGenerationForm.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</div>
